<template>
  <div class="wrap-container">
    <el-container>
      <el-header :style="headerStyle">
        <zws-header
          :navMenuModeIsHorizontal="navMenuModeIsHorizontal"
          @menuSwitch="menuSwitch"
          v-on:systemSetupDialog="getSystemSetupDialog"
        ></zws-header>
      </el-header>
      <el-container class="content-container">
        <el-aside width="auto">
          <zws-aside
            :navMenuModeIsHorizontal="navMenuModeIsHorizontal"
            :isCollapse="isCollapse"
          ></zws-aside>
        </el-aside>
        <el-container>
          <el-main
            :style="{
              minHeight: navMenuModeIsHorizontal
                ? height - 37 + 'px'
                : height + 80 + 'px'
            }"
          >
            <router-view
              :class="[
                'label-content',
                navMenuModeIsHorizontal ? 'label-nav-hori' : 'label-nav-ver'
              ]"
            ></router-view>
          </el-main>
        </el-container>
      </el-container>
      <el-footer height="36px">
        <zws-footer></zws-footer>
      </el-footer>
    </el-container>
    <el-dialog
      title="系统设置"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="item-wrapper">
        <span>主题色</span>
        <theme-picker
          :defaultThemeColor="defaultThemeColor"
          v-on:selectedColor="getSelectedColor"
        ></theme-picker>
      </div>
      <div class="item-wrapper">
        <span>水平布局</span>
        <el-switch v-model="navMenuH"> </el-switch>
      </div>
      <div class="item-wrapper">
        <span>英文</span>
        <el-switch v-model="isEnglish"> </el-switch>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import zwsHeader from "./Container/ZWSHeader.vue";
import zwsAside from "./Container/ZWSAside.vue";
import zwsMain from "./Container/ZWSMain.vue";
import zwsFooter from "./Container/ZWSFooter.vue";
import ThemePicker from "../Common/ZWSComponent/ThemePicker.vue";
import { ZWSProject } from "@/native/ZWSProject.js";
import { mapGetters } from "vuex";
export default {
  components: {
    zwsHeader,
    zwsAside,
    zwsMain,
    zwsFooter,
    ThemePicker
  },
  props: {
    // 默认水平模式
    navMenuModeIsHorizontal: {
      type: Boolean,
      default: true
    },
    defaultThemeColor: {
      type: String
    }
    // height: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      centerDialogVisible: false,
      isEnglish: false,
      isCollapse: false,
      themeColor: this.defaultThemeColor,
      menu: ""
    };
  },
  created() {
    this.menu = ZWSProject.projectMenu;
  },
  computed: {
    ...mapGetters(["height"]),
    headerStyle() {
      return {
        backgroundColor: this.themeColor
      };
    },
    navMenuH: {
      get() {
        return this.navMenuModeIsHorizontal;
      },
      set(val) {
        this.$emit("getNavMenu", val);
      }
    }
  },
  methods: {
    menuSwitch() {
      this.isCollapse = !this.isCollapse;
    },
    getSystemSetupDialog(value) {
      this.centerDialogVisible = value;
    },
    getSelectedColor(value) {
      this.themeColor = value;
      this.bus.$emit("selectedColor", value);
    }
  }
};
</script>
<style>
.wrap-container {
  height: 100%;
}
.el-header {
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
  color: #fff;
  text-align: right;
  padding: 0px !important ;
  line-height: 60px;
}
.content-container {
  padding-top: 60px;
  overflow: hidden;
}
.el-aside {
  background-color: #fff;
  color: #333333;
  text-align: left;
  line-height: 100%;
}
.el-main {
  background-color: #fff;
  position: relative;
  padding: 0px !important;
  padding-left: 6px !important;
}
.label-content {
  /* width: 80%; */
  width: calc(100% - 200px);
  background-color: #fff;
  margin: 0 auto;
}
.label-nav-hori {
  padding-top: 80px;
}
.label-nav-ver {
  width: 100%;
  max-width: 100%;
  padding: 10px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.el-footer {
  background-color: #f5f7fa;
  text-align: center;
  line-height: 35px;
  border-top: 1px solid #c5dbea;
  /* position: fixed; */
  /* bottom: 0; */
  /* width: 100%; */
}
.item-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 30px;
  margin-right: 30px;
}
body > .el-container {
  margin-bottom: 40px;
}
.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}
.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
/* .el-dialog__header {
  background-color: black;
}
.el-dialog__title {
  color: #ffffff !important;
}
.el-icon-close:before {
  color: #ffffff !important;
} */
</style>



// WEBPACK FOOTER //
// third_party/common_app/HomeModule/ZWSHome.vue